// extracted by mini-css-extract-plugin
export default {"down_bar":"Footer_down_bar__SqRIG"};